import { useQuery } from "react-query";
import inspectionTypeApi from "../utils/api/inspectionTypes";

export function useInspectionTypes() {
  return useQuery("inspectionTypes", () => inspectionTypeApi.index());
}
